<template>
  <v-card class="d-flex pa-4 flex-column" outlined>
   <TableSearchFilter
      :search="filterValue"
      @search="updateSearch" 
      @showType="showType"
      :filters="filterType"
    />
    <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :expandedItem="true"
      :refreshTable="getData"
      item-key="_id"
    >
      <template v-slot:expanded-item="{ item }">
        <LogExpandedDetail 
          :item="item" 
          :colspan="headers.length" 
          :fields="expandedFields" 
        />
      </template>


      <template v-slot:custom_status="{ item }">
               <div class="grid-layout">
              <div>
                <strong>Status:</strong> 
                <span :style="{ color: item.status === 'success' ? 'green' : (item.status === 'failed' ? 'red' : 'black') }">
                  {{ item.status }}
                </span>
              </div>
              <div>
                <strong>Reference:</strong> {{ item.reference || ''}}
              </div>
              <div>
                <strong>RRN:</strong> {{ item.response_raw?.QRPaymentCreditRS?.transactionData?.rrn || '' }}
              </div>
              <div>
                <strong>Hostname:</strong> {{ item.hostname }}
              </div>
            </div>
      </template>
    </TableView>
    </v-card>
    
  </template>

<script>
import merchantApiMixin from "@components/system-log/service-log/merchant-api/merchantApiMixin.js";

export default {
  mixins: [ merchantApiMixin ],
  components: {
    TableSearchFilter: () => import("@components/@drontVue/components/SearchFilter/TableSearchFilter.vue"),
    TableView: () => import("@components/@drontVue/components/Table/TableView.vue"),
    LogExpandedDetail: () => import("@components/@drontVue/components/LogExpandedDetail.vue"),
  },

};
</script>
<style scoped>
.button-expand {
  padding: 0 !important; 
}
.grid-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px; 
  padding: 5px;
}

.grid-layout div {
  margin-bottom: 10px; 
}
</style>
